import { render, staticRenderFns } from "./section6.vue?vue&type=template&id=7a9a13f0&scoped=true"
import script from "./section6.vue?vue&type=script&lang=js"
export * from "./section6.vue?vue&type=script&lang=js"
import style0 from "./section6.vue?vue&type=style&index=0&id=7a9a13f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9a13f0",
  null
  
)

export default component.exports